(() => {
  /**
   * Quickview modal
   */
  if (!customElements.get("quickview-modal")) {
    class QuickviewModal extends ModalDialog {
      constructor() {
        super();
        this.addEventListener("click", (event) => {
          if (event.target.nodeName === "QUICKVIEW-MODAL") this.hide();
        });
      }

      renderSection(quickviewSection) {
        this.querySelector("[data-content]").innerHTML =
          quickviewSection.outerHTML;
      }
    }

    customElements.define("quickview-modal", QuickviewModal);
  }

  /**
   * Quickview opener
   */
  if (!customElements.get("quickview-opener")) {
    class QuickviewOpener extends HTMLElement {
      constructor() {
        super();
        this.requestUrl = `${this.dataset.product}${
          this.dataset.product.includes("?") ? "&" : "?"
        }section_id=product-quickview`;
        this.button = this.querySelector("button");

        if (!this.button) return;
        this.button.addEventListener("click", this.openQuickview.bind(this));
      }

      openQuickview() {
        this.fetchInfo()
          .then((quickviewSection) => {
            const modal = document.querySelector(this.dataset.modal);
            if (!modal) return;
            modal.renderSection(quickviewSection);
            modal.show(this.button);
          })
          .catch((error) => console.error(error));
      }

      fetchInfo() {
        return new Promise((resolve, reject) => {
          fetch(this.requestUrl)
            .then((response) => response.text())
            .then((responseText) => {
              const html = new DOMParser().parseFromString(
                responseText,
                "text/html"
              );
              const quickviewSection = html.getElementById("product-quickview");
              if (!quickviewSection) reject("Quickview Section not found");

              resolve(quickviewSection);
            });
        });
      }
    }

    customElements.define("quickview-opener", QuickviewOpener);
  }
})();
